import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "number",
  "squawk",
  "reported",
  "decision",
  "verified",
  "customer",
  "work_order",
  "value",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const FIXED_COLUMNS: Column[] = ["number", "squawk"]

export const DEFAULT_COLUMNS: Column[] = [
  "number",
  "squawk",
  "reported",
  "decision",
  "verified",
  "customer",
]

export const COLUMN_LABELS: Record<Column, string> = {
  number: "Squawk no.",
  squawk: "Squawk",
  reported: "Reported",
  decision: "Decision",
  verified: "Verified",
  customer: "Customer review",
  work_order: "Work order",
  value: "Value",
}

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "squawks",
  widths: {
    number: 6,
    squawk: 10,
    reported: 6.5,
    decision: 7,
    verified: 6.5,
    customer: 8,
    work_order: 6,
    value: 8,
    select: 2.25,
    severity: 2.5,
    status: 1.75,
    actions: 7.5,
  },
  fill: "squawk",
  pinned: ["select", "severity", "status", "actions"],
  extras: ["select", "severity", "status", "actions"],
  dropOrder: [
    "work_order",
    "value",
    "customer",
    "reported",
    "verified",
    "decision",
  ],
}

export type Slot = Column | "select" | "severity" | "status" | "actions"

export function withFixed(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => FIXED_COLUMNS.includes(column) || columns.includes(column),
  )
}

export function slotsOf(columns: Column[]): Slot[] {
  const rest = COLUMNS.filter(
    (column) =>
      column !== "number" && column !== "squawk" && columns.includes(column),
  )
  return [
    "select",
    "severity",
    "number",
    "status",
    "squawk",
    ...rest,
    "actions",
  ]
}
